export const LpaOrAcpUrlBaseUrl = "/find-a-service/start-preparing-lpa-and-acp";

export const LpaOrAcpUrl = {
	landingPage: LpaOrAcpUrlBaseUrl,
};
